import {AUTH, GET_REFRESH_TOKEN, SERVICE_ID, SET_COOKIE, UPDATE_REFRESH_TOKEN} from "./Const";
import {jwtDecode} from "jwt-decode";
import { useState } from 'react';

// Кастомный хук для блокировки повторных запросов
export const useButtonLock = () => {
    const [isDisabled, setIsDisabled] = useState(false);

    const lockButton = () => {
        setIsDisabled(true);
    };

    const unlockButton = () => {
        setIsDisabled(false);
    };

    return { isDisabled, lockButton, unlockButton };
};


async function FetchElements(
    url,
    method,
    func,
    navigate,
    retries = 2,
    navigationFunc,
    showAlert = () => {},
    attempt = 0,
    body = null,
    ignoreStatusCodes = [],
    disableNavigationOnError = false,
    returnFullResponse = false
) {
    let accessToken = GetCookie("access_token");

    let responseStatusCode;

    try {
        const requestConfig = {
            method: method,
            headers: {
                "Accept": "application/json",
                "access-token": `${accessToken}`,
            },
        };

        if (body !== null && body !== undefined) {
            requestConfig.body = JSON.stringify(body);
            requestConfig.headers["Content-Type"] = "application/json";
        }

        const response = await fetch(url, requestConfig);
        responseStatusCode = response.status;

        if (ignoreStatusCodes.includes(response.status)) {
            const data = await response.json().catch(() => ({}));
            // Если нужен полный ответ, отдаем data, иначе только data.data
            func(returnFullResponse ? data : (data.data || []));
            return;
        }

        if (!response.ok) {
            let data = await response.json();
            if (response.status === 403) {
                localStorage.clear();
                deleteCookie("access_token");
                window.location.reload();
                throw new Error(`${data.message}`);
            } else if (response.status === 401) {
                await updateRefreshToken("", "", navigationFunc);
                throw new Error(`${data.message}`);
            } else {
                throw new Error(`${data.message}`);
            }
        } else {
            const data = await response.json();
            // Если нужен полный ответ, отдаем data, иначе только data.data
            func(returnFullResponse ? data : data.data);
        }

    } catch (error) {
        console.error(`Попытка ${attempt} завершилась ошибкой:`, error);
        if (attempt < retries) {
            await FetchElements(
                url,
                method,
                func,
                navigate,
                retries,
                navigationFunc,
                showAlert,
                attempt + 1,
                body,
                ignoreStatusCodes,
                disableNavigationOnError,
                returnFullResponse // <-- Прокидываем дальше при ретрае
            )
        } else {
            if (!ignoreStatusCodes.includes(responseStatusCode)) {
                showAlert("Ошибка", error.message, responseStatusCode);
                if (!disableNavigationOnError && navigationFunc) {
                    setTimeout(navigationFunc, 1500);
                }
            } else {
                func([]);
            }
        }
    }
}
export {FetchElements}

// Обновление рефреш токена
async function updateRefreshToken(
    setAccesToken = null,
    setRefreshToken = null,
    navigationFuncFailed = function(){},
    alertFunc = function(){},
    navigationFuncOK = function(){},
)
{
    let refreshToken = GET_REFRESH_TOKEN();

    if (refreshToken !== null && refreshToken !== undefined) {
        let data = {
            "refresh_token": refreshToken,
        }
        data = JSON.stringify(data)
        let response = await fetch(
            `${AUTH}/api/token/refresh?service_id=${SERVICE_ID}&device=web`,
            {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
                body: data,
            });

        let result = await response.json();

        let status = response.status;

        if (status >= 200 && status < 300) {

            SET_COOKIE("access_token", result.data.access_token.value, result.data.access_token.max_age);
            UPDATE_REFRESH_TOKEN(result.data.refresh_token.value);

            if (setAccesToken) {
                setAccesToken(GetCookie("access_token"));
            }
            if (setRefreshToken) {
                setRefreshToken(result.data.refresh_token.value);
            }

            return true

        }else if (response.status === 400){

            navigationFuncFailed()

            return false

        } else {

            localStorage.clear();
            sessionStorage.clear();
            deleteCookie("access_token");
            console.error("Ошибка обновления токена", result.error)
            alertFunc();
            navigationFuncFailed()

            return false

        }
    } else {
        navigationFuncFailed()
        return false
    }
}
export {updateRefreshToken}

// получение куки getCookie
function GetCookie(name) {
    const cookieArray = document.cookie.split('; ');
    for (const cookie of cookieArray) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName.trim() === name) {
            return cookieValue;
        }
    }
    return null;
}
export {GetCookie};


function Request(
    method,
    url,
    json = null,
    form_data = null,
    onsuccess = function(){},
    onerror = function(){},
    onprogress = function(){},
    onloadstart = function(){},
    ondelete = function(){},
    controller = null,
) {
    let request = new XMLHttpRequest();
    request.open(method, url, true);

    if (json !== null) {
        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    }

    request.onload = function () {
        let responseObj = JSON.parse(request.response);
        console.debug(method, url, responseObj);
        if (request.status >= 400) {
            console.debug(method, url, request.status, request);
            alert(responseObj.message);
            ondelete();
        } else {
            if (responseObj.result === true) {
                onsuccess(responseObj);
            } else {
                onerror(responseObj);
            }
        }
    };

    request.upload.onloadstart = function () {
        onloadstart();
    };

    request.upload.onprogress = function (event) {
        onprogress(event);
    };

    request.onreadystatechange = function () {};

    request.onerror = function () {
        console.debug(method, url, request.status, request);
    };

    request.ontimeout = function () {
        console.debug(method, url, request.status, request);
    };

    // Добавляем обработчик отмены
    request.onabort = function () {
        console.debug(method, url, request.status, "Загрузка отменена");
    };

    // Функция отмены
    const abortRequest = () => {
        request.abort();
    };

    // Если передан AbortController, слушаем событие abort
    if (controller) {
        controller.signal.addEventListener('abort', abortRequest);
    }

    if (json != null) {
        request.send(JSON.stringify(json));
    } else if (form_data != null) {
        request.send(form_data);
    } else {
        request.send();
    }

    return abortRequest;
}
export {Request}



function deleteCookie(name) {
    document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}
export {deleteCookie}

function decodeTokens(
    navigationFunc = function(){}
){

    let token = GetCookie("access_token");
    let decodedToken;

    if (token) {
        try {
            decodedToken = jwtDecode(token);
        } catch (err) {
            console.error("Ошибка декодирования токена:", err);
            return;
        }

        if (decodedToken && decodedToken.user) {
            try {
                let user = JSON.parse(decodedToken.user);

                if (user.extended_object?.shop_id && user.extended_object.shop_id.length !== 0) {
                    localStorage.setItem("TOKEN_SHOP_ID", user.extended_object.shop_id);
                }

                if (user.roles && user.roles.length > 0) {
                    localStorage.setItem("ROLE", user.roles[0].name);
                } else if (user.role) {
                    let role = user.role.name;
                    localStorage.setItem("ROLE", role);
                }
            } catch (e) {
                console.error("Ошибка парсинга user из токена:", e);
            }
        }
    }
}
export {decodeTokens}